import React, { Component } from 'react';
import { connect } from 'react-redux';
import set from 'lodash/set';
import fetchStaticPage from 'actions/CheckoutActions/staticPageActions';
import Loader from 'components/Common/Loader/Loader';
import Error from 'components/Error/Error';
import { isInit, isSuccess, isError, isLoading } from 'utils/asyncStatusHelper';
import MarkdownWidget from 'components/MarkdownWidget/MarkdownWidget';
import Card from 'components/Common/Card/Card';
import styles from './StaticPage.css';
import get from 'lodash/get';
export class StaticPage extends Component {
    componentDidMount() {
        this.props.fetchStaticPage(this.props.pageId);
    }
    render() {
        const { staticPage } = this.props;
        const markdownText = get(staticPage, [
            'slots',
            '0',
            'widget',
            'data',
            'renderableComponents',
            '0',
            'value',
            'content'
        ]);
        const showLoader = isLoading(staticPage) || isInit(staticPage);
        const showMarkdown = markdownText && isSuccess(staticPage);
        const showError = isError(staticPage) || (!showLoader && !showMarkdown);
        let widgetData = {};
        if (showMarkdown) {
            // Setting response in v4 format
            const widget = {};
            widgetData = set(widget, 'data.renderableComponents[0].value.content', markdownText);
        }
        return (<div className={styles['static-page-container']}>
				<Card className={styles['static-page-content']}>
					{showLoader && <Loader className={styles['loader']}/>}
					{showMarkdown && <MarkdownWidget widget={widgetData}/>}
					{showError && <Error />}
				</Card>
			</div>);
    }
}
const mapStateToProps = state => {
    return {
        staticPage: state.staticPage
    };
};
const mapDispatchToProps = {
    fetchStaticPage
};
export default connect(mapStateToProps, mapDispatchToProps)(StaticPage);
